import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDevicesPayloadState } from '@app-store/slices/companyStatistics/devices'

interface TaskAction extends Action {
    payload: IDevicesPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.companyStatistics.devices

function* devicesSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/stats/devices`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* devicesSaga(): any {
    yield takeLatest<TaskAction>(onRequest, devicesSagaTask)
}

export default devicesSaga
